import { ApiUrls } from '@/service/constants/urls';

export const DummyImage = ({ className }: { className?: string }) => (
    <img
        className={`h-full w-full object-cover ${className || ''}`}
        src={ApiUrls.photo.dummy}
        alt={'Image Not Found'}
    />
);
